import { Button } from "@progress/kendo-react-buttons";
import moment from "moment";
import React from "react";
import Swal from "sweetalert2";
import * as OxzionGUIComponents from "../../../index";
import Dashboard from "../../components/OI/Dashboard";
import DashboardManager from "../../components/OI/DashboardManager";
import DocumentViewer from "../../DocumentViewer";
import Helpers from "../../helpers";
import CustomMapComponent from "../MapComponent/CustomMapComponent";
import UploadArtifact from "../UploadArtifact";
import ActivityLog from "./ActivityLog";
import CommentsView from "./CommentsView";
import DynamicTemplateViewer from "./DynamicTemplateViewer";
import EntityViewer from "./EntityViewer";
import FormRender from "./FormRender";
import HTMLViewer from "./HTMLViewer";
import Page from "./Page";
import RenderButtons from "./RenderButtons";
import TabSegment from "./TabSegment";
import OX_Grid from "../Grid/OX_Grid";
import { buttonAction } from "../Grid/GridHelpers/listViewHelpers";

import "./Styles/PageComponentStyles.scss";

class PageContent extends React.Component {
  constructor(props) {
    super(props);
    this.core = this.props.core;
    this.appId = this.props.appId;
    this.proc = this.props.proc;
    this.appName = this.props.proc.metadata?.name;
    this.pageId = this.props.pageId;
    this.contentRef = React.createRef();
    this.params = this.props.params;
    this.notif = this.props.notif;
    this.userprofile = this.props.core.make("oxzion/profile").get().key;
    this.restClient = this.core.make("oxzion/restClient");
    this.isTab = this.props.isTab;
    this.parentPage = this.props.parentPage ? this.props.parentPage : null;
    this.loader = this.core.make("oxzion/splash");
    this.parentPageData = props.parentRowData;
    this.contentDivID = "content_" + this.appId + "_" + (this.pageId ? this.pageId : Helpers.Utils.generateUUID());
    this.alertAdapter = this.core?.make("oxzion/alert");

    this.state = {
      pageContent: this.props.pageContent ? this.props.pageContent : [],
      pageId: this.props.pageId,
      submission: this.props.submission,
      showLoader: false,
      fileData: this.props.fileData ? this.props.fileData : {},
      fileId: this.props.fileId ? this.props.fileId : null,
      isMenuOpen: false,
      currentRow: this.props.currentRow ? this.props.currentRow : {},
      title: "",
      notif: this.notif,
      displaySection: "DB",
      sectionData: null,
    };
  }

  componentWillUnmount() {
    this.restClient.clearMemoizedData(this.appId, "FILE");
  }

  componentDidUpdate(prevProps) {
    if (this.props.pageContent !== prevProps.pageContent) {
      var PageRenderDiv = document.querySelector(".PageRender");
      this.loader.show(PageRenderDiv);
      this.setState({ pageContent: this.props.pageContent });
    }
  }

  // renderRow(e, config) {
  //   var url = config[0].content.route;
  //   var dataString = this.prepareDataRoute(url, e);
  //   return (
  //     <OX_Grid
  //       appId={this.appId}
  //       appName={this.appName}
  //       osjsCore={this.core}
  //       data={dataString}
  //       pageId={this.pageId}
  //       gridToolbar={config[0].content.toolbarTemplate}
  //       columnConfig={config[0].content.columnConfig}
  //     />
  //   );
  // }

  prepareDataRoute(route, params = {}, disableAppId) {
    if (typeof route !== "string") return route;
    var result = Helpers.ParameterHandler.replaceParams(this.appId, route, params);
    return disableAppId ? result : "app/" + this.appId + "/" + result;
  }

  setTitle = (title) => {
    this.setState({ title: title });
  };

  hideMenu = () => {
    this.setState({ isMenuOpen: false });
  };

  switchSection = (section, data) => {
    this.hideMenu();
    this.setState({
      displaySection: section,
      sectionData: data,
    });
  };
  editDashboard = (data) => {
    this.switchSection("EDB", data);
  };

  postSubmitCallback = () => {
    this.props.postSubmitCallback?.();
    let ev = new CustomEvent("handleGridRefresh", {
      detail: { hideLoader: true },
      bubbles: true,
    });
    if (document.getElementById("navigation_" + this.appId)) {
      document.getElementById("navigation_" + this.appId).dispatchEvent(ev);
    }
  };
  renderContent(data) {
    var content = [];
    data.map((item, i) => {
      var that = this;
      if (item.type == "Form") {
        delete item.additionalPayload;
        var cacheId = Helpers.ParameterHandler.replaceParams(this.appId, item.cacheId, this.state.currentRow);
        var urlPostParams = Helpers.ParameterHandler.replaceParams(this.appId, item.urlPostParams, this.state.currentRow);
        var fileId = Helpers.ParameterHandler.replaceParams(this.appId, item.content ? item.content.fileId : item.fileId, this.state.currentRow);
        var formId = item.content ? item.content.form_id : item.form_id;
        item.formSuccessMessage = item?.content?.formSuccessMessage || item?.formSuccessMessage;
        if (formId) {
          delete item.content;
        }
        try {
          item.data = Helpers.ParameterHandler.replaceParams(this.appId, item.data, this.state.currentRow);
        } catch (err) {
          console.log(err);
        }
        content.push(
          <FormRender
            {...item.config}
            {...item}
            data={item.data ? item.data : item?.config?.data}
            key={i}
            urlPostParams={urlPostParams}
            core={this.core}
            proc={this.proc}
            appId={this.appId}
            postSubmitCallback={this.postSubmitCallback}
            fileId={fileId}
            formId={formId}
            notif={this.notif}
            cacheId={cacheId}
            pageId={this.state.pageId}
            dataUrl={this.prepareDataRoute(item.dataUrl, this.state.currentRow, true)}
          />,
        );
      } else if (item.type == "List") {
        var itemContent = item.gridContent ? item.gridContent : item.content;
        itemContent.pageContentId = item.page_content_id;
        itemContent?.pageable?.pageSizes?.includes(10) ? "" : itemContent?.pageable?.pageSizes?.unshift(10);
        itemContent.pageable.buttonCount = parseInt(itemContent?.pageable?.buttonCount ?? 3);
        var columnConfig = itemContent?.columnConfig;
        var mergeRowData = this.props.params ? { ...this.props.params, ...this.state.currentRow } : this.state.currentRow;
        var dataString = this.prepareDataRoute(itemContent?.route, mergeRowData, itemContent?.disableAppId);
        var urlPostParams = Helpers.ParameterHandler.replaceParams(this.appId, item.urlPostParams, mergeRowData);
        var listOptions = itemContent?.listOptions;
        if (listOptions?.configurableColumns) {
          columnConfig.map((a, i) => {
            if (a.default) a.show = a.default;
            // a.orderIndex=a.orderIndex?a.orderIndex:i;
          });
        }
        var that = this;
        if (itemContent?.operations) {
          if (itemContent?.operations?.actions) {
            itemContent?.operations?.actions?.map((action, j) => {
              action.title = action.name;
              action.configurationCallback = () => buttonAction(action, {}, { core: this.core, appId: this.appId, currentRow: this.state.currentRow });
              var act = action;
              if (Array.isArray(act.details)) {
                act.details.map((detail, k) => {
                  if (detail.params) {
                    Object.keys(detail.params).map(function (key, index) {
                      detail.params[key] = Helpers.ParameterHandler.replaceParams(that.appId, detail.params[key], mergeRowData);
                    });
                  }
                });
              }
            });
          }
        }
        content.push(
          <OX_Grid
            key={i}
            gridDefaultFilters={
              itemContent?.defaultFilters
                ? typeof itemContent?.defaultFilters == "string"
                  ? JSON.parse(Helpers.ParameterHandler.replaceParams(this.appId, itemContent?.defaultFilters, mergeRowData))
                  : JSON.parse(Helpers.ParameterHandler.replaceParams(this.appId, JSON.stringify(itemContent?.defaultFilters), mergeRowData))
                : undefined
            }
            core={that.props.core}
            proc={that.proc}
            // pivotGrid={listOptions?.pivotGrid}
            currentRow={mergeRowData}
            dataLoaderComponent={"DataLoader"}
            columnConfig={
              columnConfig?.map((config) => {
                if (config.cell) {
                  config.cellTemplate = config.cell;
                  delete config.cell;
                }
                return config;
              }) || []
            }
            dataSource={dataString}
            appId={that.appId}
            pageId={that.state.pageId}
            parentDiv={this.contentDivID}
            isRelationTab={this.state?.pageContent[0]?.gridContent?.relation_name ?? ""}
            relationsParentRoute={this.state?.pageContent[0]?.gridContent?.relationsParentRoute ?? "/file"}
            {...itemContent}
            actionButtonType={itemContent.disableContextAction}
            listOptions={{
              ...listOptions,
              exportToExcel: { enabled: listOptions?.exportToExcel, config: itemContent.exportToExcel },
              exportToPdf: { enabled: listOptions?.exportToPdf, config: itemContent.exportToPdf },
              massUpdate: { enabled: listOptions?.checkBoxSelection, config: itemContent.massUpdateConfig },
              groupable: { enabled: listOptions?.groupable, config: itemContent.groupableColumnsConfig },
              autoRefresh: { enabled: listOptions?.autoRefresh, config: itemContent.autoRefresh },
            }}
            notif={this.notif}
          />,
        );
      } else if (item.type == "DocumentViewer") {
        var url;
        if (item.url) {
          url = Helpers.ParameterHandler.replaceParams(this.appId, item.url, this.state.currentRow);
        }
        if (item.content) {
          url = Helpers.ParameterHandler.replaceParams(this.appId, item.content, this.state.currentRow);
        }
        content.push(
          <DocumentViewer appId={this.appId} key={i} core={this.core} url={url} entityConfig={item.entityConfig} fileData={this.state.currentRow} />,
        );
      } else if (item.type == "RenderButtons") {
        content.push(
          <RenderButtons
            appId={this.appId}
            key={i}
            ref={this.contentRef}
            core={this.core}
            proc={this.proc}
            pageId={this.state.pageId}
            notif={this.notif}
            currentRow={this.state.currentRow}
            {...item}
          />,
        );
      } else if (item.type == "Comment") {
        var url;
        var that = this;
        if (item.content) {
          url = Helpers.ParameterHandler.replaceParams(this.appId, item.content, this.state.currentRow);
        } else {
          if (item.url) {
            url = Helpers.ParameterHandler.replaceParams(this.appId, item.url, this.state.currentRow);
          }
        }
        var fileId = item.fileId ? item.fileId : that.props.currentRow.uuid ? that.props.currentRow.uuid : null;

        content.push(
          <CommentsView
            {...item}
            pageId={this.state.pageId}
            appId={this.appId}
            key={i}
            core={this.core}
            url={url}
            notif={this.notif}
            fileId={fileId}
            currentRow={this.state.currentRow}
          />,
        );
      } else if (item.type == "TabSegment") {
        content.push(
          <TabSegment
            appId={this.appId}
            key={i}
            core={this.core}
            notif={this.notif}
            proc={this.props.proc}
            fileId={fileId}
            tabs={item.content.tabs}
            pageId={this.state.pageId}
            currentRow={this.state.currentRow}
          />,
        );
      } else if (item.type == "Dashboard") {
        content.push(<Dashboard appId={this.appId} key={i} core={this.core} notif={this.notif} content={item.content} proc={this.proc} />);
      } else if (item.type == "DashboardManager") {
        var itemContent = item.gridContent ? item.gridContent : item.content;
        if (itemContent?.dashboardoperations) {
          if (itemContent?.dashboardoperations.dashboardactions) {
            itemContent?.dashboardoperations.dashboardactions.map((action, j) => {
              var act = action;
              if (Array.isArray(act.details)) {
                act.details.map((detail, k) => {
                  if (detail.params) {
                    Object.keys(detail.params).map(function (key, index) {
                      detail.params[key] = Helpers.ParameterHandler.replaceParams(this.appId, detail.params[key], mergeRowData);
                    });
                  }
                });
              }
            });
          }
        }
        var dashboardoperations = Helpers.ParameterHandler.replaceParams(this.appId, itemContent?.dashboardoperations);
        var uuid = item.content ? (item.content.uuid ? item.content.uuid : null) : null;
        content.push(
          <DashboardManager
            appId={this.appId}
            uuid={uuid}
            content={item.content}
            notif={this.notif}
            args={this.core}
            key={i}
            setTitle={() => {}}
            proc={this.proc}
            editDashboard="EDB"
            hideEdit={true}
            dashboardoperations={dashboardoperations}
            parentDiv={this.contentDivID}
            customActions={this.props.customActions}
          />,
        );
      } else if (item.type == "Page") {
        var mergeRowData = this.props.params ? { ...this.props.params, ...item.params } : item.params;
        var params = Helpers.ParameterHandler.replaceParams(this.appId, mergeRowData, this.state.currentRow);
        content.push(
          <Page
            key={item.page_id}
            config={this.props.config}
            proc={this.props.proc}
            isTab={this.isTab}
            parentPage={this.parentPage}
            app={this.props.appId}
            notif={this.notif}
            currentRow={this.state.currentRow}
            pageId={item.page_id}
            core={this.core}
            {...params}
          />,
        );
      } else if (item.type == "Document" || item.type == "HTMLViewer") {
        var fileData = this.state.fileData && this.state.fileData != {} ? this.state.fileData : this.state.currentRow;
        var fileId = item.fileId ? item.fileId : this.state.currentRow.uuid;
        if (item.useRowData) {
          item.content = Helpers.ParameterHandler.replaceParams(this.appId, item.content, this.state.currentRow);
        }
        if (item.contentRouteUrl) {
          item.contentRouteUrl = Helpers.ParameterHandler.replaceParams(this.appId, item.contentRouteUrl, this.state.currentRow);
        }
        content.push(
          <HTMLViewer
            key={i}
            core={this.core}
            appId={this.appId}
            proc={this.props.proc}
            url={item.url ? Helpers.ParameterHandler.replaceParams(this.appId, item.url, this.state.currentRow) : undefined}
            fileId={fileId}
            content={item.content ? item.content : ""}
            fileData={fileData}
            notif={this.notif}
            className={item.className}
            item={item}
            currentRow={this.state.currentRow}
          />,
        );
      } else if (item.type == "EntityViewer") {
        var fileId = this.props.fileId ? this.props.fileId : this.state.currentRow.uuid;
        content.push(
          <EntityViewer
            item={item}
            extGUIComponents={this.props.extGUIComponents}
            pageId={this.state.pageId}
            key={i}
            core={this.core}
            appId={this.appId}
            proc={this.props.proc}
            fileId={item.fileId ? item.fileId : fileId}
            notif={this.notif}
            fileData={this.state.currentRow}
            className={item.className}
            edit={item.edit}
          />,
        );
      } else if (item.type == "History") {
        var fileId = this.props.fileId ? this.props.fileId : item.fileId ? item.fileId : this.state.currentRow.uuid;
        content.push(<ActivityLog key={i} appId={this.appId} fileId={fileId} core={this.core} />);
      } else if (item.type === "CustomPage") {
        var fileId = this.props.fileId ? this.props.fileId : this.state.currentRow.uuid;
        return content.push(
          <DynamicTemplateViewer key={i} appId={this.appId} fileId={fileId} core={this.core} data={item.content} rowData={this.state.currentRow} />,
        );
      } else if (item.type == "KanbanViewer") {
        content.push(
          <KanbanView
            core={this.core}
            key={i}
            appId={this.appId}
            filters={item.content.filters}
            url={item.content.url}
            options={item.content.options}
            ymlData={item.content.ymlData}
          />,
        );
      } else if (item.type == "MapViewer") {
        content.push(<CustomMapComponent key={i} core={this.core} appId={this.appId} />);
      } else if (item.type == "UploadArtifact") {
        item.params = Helpers.ParameterHandler.replaceParams(this.appId, item.params, this.state.currentRow);
        content.push(
          <UploadArtifact
            {...item}
            key={i}
            components={OxzionGUIComponents}
            appId={this.appId}
            notif={this.notif}
            core={this.core}
            refresh={this.postSubmitCallback}
          ></UploadArtifact>,
        );
      } else {
        var fileId = that.props.fileId ? that.props.fileId : that.state.currentRow.uuid;
        if (that.props.extGUIComponents && that.props.extGUIComponents.guiComponent[item.content.reactId]) {
          that.externalComponent = that.props.extGUIComponents.guiComponent[item.content.reactId];
          item.params = Helpers.ParameterHandler.replaceParams(that.state.appId, item.params, that.state.currentRow);
          let guiComponent = (
            <that.externalComponent
              {...item}
              {...that.props}
              params={item.params}
              fileId={fileId}
              parentPageData={that.parentPageData}
              key={i}
              components={OxzionGUIComponents}
              appId={that.appId}
              notif={that.notif}
              core={that.core}
              refresh={that.postSubmitCallback}
              data={item.content}
              componentProps={that}
            ></that.externalComponent>
          );
          content.push(guiComponent);
        } else {
          console.error("component ", item.content.reactId, " not found");
          content.push(<h3 key={i}>The component used is not available.</h3>);
        }
      }
    });
    if (content.length > 0) {
      this.loader.destroy();
    } else {
      content.push(<h2>No Content Available</h2>);
      this.loader.destroy();
    }
    return content;
  }

  render() {
    if (this.state.pageContent && this.state.pageContent.length > 0 && !this.state.showLoader) {
      this.loader.destroy();
      var pageRender = this.renderContent(this.state.pageContent);
      return (
        <div id={this.contentDivID} className="contentDiv">
          {pageRender}
        </div>
      );
    } else {
      return <div id={this.contentDivID}></div>;
    }
  }
}

export default PageContent;
